import * as types from '@/store/mutation-types';

const state = {
  action: {
    save: false,
    type: '',
  },
};

const getters = {
  activeAction(state) {
    return state.action;
  },
};

const mutations = {
  [types.SET_SITE_SAVED](state, p) {
    state.action.save = p.status;
    state.action.type = p.type;
  },
};

const actions = {
  async setSiteSave({ commit }, payload) {
    await commit(types.SET_SITE_SAVED, payload);
    let t;
    clearTimeout(t);
    t = setTimeout(() => {
      commit(types.SET_SITE_SAVED, { status: false, type: '' });
    }, 1200);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/save-alert/vuex.js